import { createBrowserRouter, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/Landing';
import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { VerifyPage } from './pages/Verify';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { ResetPasswordPage } from './pages/ResetPassword';
import { SharePage } from './pages/SharePage';
import { SpacesPage } from './pages/Spaces';
import { WorkspaceLayout } from './layouts/WorkspaceLayout';
import { DocListPage } from './pages/DocList';
import { DocEditorPage } from './pages/DocEditor';
import { MindmapListPage } from './pages/MindmapList';
import { MindmapEditorPage } from './pages/MindmapEditor';
import { MembersPage } from './pages/Members';
import { SettingsPage } from './pages/Settings';
import { TrashPage } from './pages/Trash';
import { PersonalSettingsPage } from './pages/PersonalSettings';
import { NotFoundPage } from './pages/NotFound';

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/verify', element: <VerifyPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/share/:token', element: <SharePage /> },
  { path: '/spaces', element: <SpacesPage /> },
  {
    path: '/space/:wsId',
    element: <WorkspaceLayout />,
    children: [
      { index: true, element: <Navigate to="docs" replace /> },
      { path: 'docs', element: <DocListPage /> },
      { path: 'docs/:docId', element: <DocEditorPage /> },
      { path: 'mindmaps', element: <MindmapListPage /> },
      { path: 'mindmaps/:mapId', element: <MindmapEditorPage /> },
      { path: 'members', element: <MembersPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'trash', element: <TrashPage /> },
    ],
  },
  { path: '/settings', element: <PersonalSettingsPage /> },
  { path: '*', element: <NotFoundPage /> },
]);
